import { apiUrl } from "@/lib/config";
import { connection } from "@/lib/connection";

const API_URL = apiUrl("/newsletter");

export type NewsletterPayload = {
  nombre: string;
  apellido: string;
  email: string;
};

export async function subscribeNewsletter(
  payload: NewsletterPayload,
  cookies?: any
) {
  // Ajustá la URL final según tu backend: "/suscribir", "/subscribe", etc.
  const data = await connection<any>(
    `${API_URL}/subscribe`,
    "POST",
    payload,
    null,
    cookies
  );

  return data;
}
